Vue.asyncComponent('bp-active-metadata',{
    props: {
        dataProvider: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            metadataHandler: null,
            metadata: [],
            supportedMetadata: [],
            loading: false
        }
    },
    computed: {
        /**
         * Blueprint id out of the url
         * @returns {any}
         */
        blueprintId() {
            return this.$route.params.blueprintId;
        },
        relationString() {
            return this.$route.params.relationString;
        }
    },
    methods: {
        /**
         * fetch the active metadata buttons
         * @returns {Promise<void>}
         */
        async getMetadata() {
            this.loading = true;
            this.metadataHandler = await this.dataProvider.getMetadataHandler();
            this.metadata = this.metadataHandler.getMetadata();
            this.supportedMetadata = await this.metadataHandler.getSupportedMetadata();
            this.loading = false;
        },
        /**
         * Set the new array of active metadata
         * @param metadata
         */
        updateMetadata(metaData) {
            this.metadataHandler.setMetadata(metaData)
            this.getMetadata();
        },
    },
    created() {
        this.getMetadata();
    }
}, 'blueprints/meta/bp-active-metadata.html');